import { useMemo } from 'react';
import { Button } from '@zeptonow/zui';
import Breadcrumb from '@zeptonow/zui/Breadcrumb';
import BreadcrumbItems from './common/component/header/breadcrumbItems';
import { filterRoutes } from './common/component/header/utils';
import RecentTabs from './common/component/recent-tabs/RecentTabs';
import SubHeader from './common/component/sub-header';
import useUserPreferenceModal from './common/component/user-preference/hooks/useUserPreferenceModal';
import { preferenceStore } from './common/component/user-preference/store';
import useHasPermission from './common/hooks/useHasPermission';
import getModuleRoutes from './common/routes/ModuleRoutes';
import { RoleConfigStore } from './common/store';
import LogoutComponent from './logout';
import { generateImage } from '@hrms/common/utils/generateImage';

const Header = () => {
  const { openUserPreferenceModal } = useUserPreferenceModal();
  const { hasModulePermission } = useHasPermission();

  const onPreferenceButtonClick = () => {
    openUserPreferenceModal({ showCancelBtn: true });
  };

  const { preference } = preferenceStore();

  const { allowTenantSiteSelection } = RoleConfigStore((state) => state);

  const moduleRoutes = useMemo(() => {
    return getModuleRoutes();
  }, []);

  const filteredRoutes =
    filterRoutes({
      routes: moduleRoutes,
      hasModulePermission,
    }) ?? [];

  const rightWidget = () => (
    <div className="flex justify-between gap-4 items-center">
      {allowTenantSiteSelection ? (
        <Button
          className="!border-gray-300 !min-w-fit !text-gray-700"
          variant="outlined"
          size="small"
          startIcon={generateImage({
            name: 'warehouse',
            alt: 'plus icon',
            className: 'w-4 h-4 mr-3',
          })}
          onClick={onPreferenceButtonClick}
          data-testid="user-preference-test"
        >
          {`${preference?.selectedTenant?.label || ''}  ${
            preference?.selectedSite?.label
              ? `| ${preference?.selectedSite?.label}`
              : ''
          }`}
        </Button>
      ) : null}
      <LogoutComponent />
    </div>
  );

  return (
    <div className="w-full">
      <SubHeader
        rightWidget={rightWidget}
        leftWidget={<Breadcrumb items={BreadcrumbItems(filteredRoutes)} />}
        className="px-5 py-3 bg-white items-center w-full h-full border-b border-gray-200 min-h-[4rem]"
      />
      <RecentTabs filteredRoutes={filteredRoutes} />
    </div>
  );
};

export default Header;
